"use client";

import { useEffect } from "react";
import { usePathname, useSearchParams } from "next/navigation";
import { usePostHog } from "posthog-js/react";

export function PostHogPageView(): null {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const posthog = usePostHog();

  useEffect(() => {
    if (!pathname) {
      return;
    }

    let currentUrl = window.location.origin + pathname;
    const queryString = searchParams.toString();

    if (queryString) {
      currentUrl += `?${queryString}`;
    }

    posthog.capture("$pageview", {
      $current_url: currentUrl,
    });
  }, [pathname, posthog, searchParams]);

  return null;
}
